import ComponentHandler from "./componentHandler";

export type { ComponentHandlerProps } from "./interface";
export default ComponentHandler;
